import { setCookie, getCookie } from '../shared/cookieHelper';
const listNLockVideoGenerationTimeout = 300;

window.showTerms = function (element) {
    $('#terms-text').html(element);
    $('#modal-terms').show();
}

window.copyToClipboard = async function (element) {
    let textToCopy = '';

    // Determine what type of input we received
    if (typeof element === 'string') {
        // Check if it looks like a selector (starts with #, ., [, or other CSS selector chars)
        if (element.match(/^[#.\[]/)) {
            // It's likely a selector string, query it
            textToCopy = $(element).text();
        } else {
            // It's a plain string value to copy directly
            textToCopy = element;
        }
    } else if (element instanceof jQuery) {
        // It's already a jQuery object
        textToCopy = element.text();
    } else if (element instanceof HTMLElement) {
        // It's a DOM element
        textToCopy = $(element).text();
    } else {
        console.error('Invalid input type for copyToClipboard');
        return;
    }

    // Use modern Clipboard API with fallback
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy);
            alert("Copied");
        } else {
            // Fallback for older browsers or non-secure contexts
            const $temp = $("<input>");
            $("body").append($temp);
            $temp.val(textToCopy).select();
            document.execCommand("copy");
            $temp.remove();
            alert("Copied");
        }
    } catch (err) {
        console.error('Failed to copy text: ', err);
        alert("Failed to copy");
    }
}

window.GinitMap2 = function () {
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
    };
    var input = document.getElementById('autocomplete');
    var countries = 'us';

};

window.thisFileUpload = function () {
    document.getElementById("listingimagefile").click();
};

$(function () {
    if ($('#locknlist_home_page').length) {
        var $loading = $('#ll_loading-div').hide();
        var $loadingform = $('#ll_loading-div-form').hide();

        $('#selectState').on('change', function (e) {
            var optionSelected = $("option:selected", this);
            var stateCode = optionSelected.text()

            var loc = $("#prefixurl").val();

            $.ajax({
                url: loc + '/get-counties/' + stateCode,
                type: 'GET',
                beforeSend: function () {
                    $loadingform.show();
                },
                success: function (response) {
                    $loadingform.hide();
                    let dropdown = document.getElementById('selectCounty');
                    dropdown.length = 0;

                    let defaultOption = document.createElement('option');
                    defaultOption.text = 'Choose County';
                    defaultOption.value = "";

                    dropdown.add(defaultOption);
                    dropdown.selectedIndex = 0;
                    var obj = jQuery.parseJSON(response);

                    let sortedObj = obj.sort((a, b) => a.Name.localeCompare(b.Name));

                    let option;

                    for (let i = 0; i < sortedObj.length; i++) {
                        option = document.createElement('option');
                        option.text = sortedObj[i].Name;
                        option.value = sortedObj[i].Code;
                        dropdown.add(option);
                    }
                    $('#selectCounty').valid();
                }
            });
        });


        $('#btnFormStart').click(function (e) {
            $("#modaladdress_ll").validate();
            if ($('#modaladdress_ll').valid()) {
                e.preventDefault();
                var form = new FormData();
                setCookie("ll_state_error", "no", 1);
                var selectedState = document.getElementById("selectState");
                var s = selectedState.options[selectedState.selectedIndex].text;
                form.append("state_lisenced", $("#state_lisenced").val());
                var sl = $("#state_lisenced").val();
                form.append("member_id", $("#member_id").val());
                form.append("branch_orgid", $("#branch_orgid").val());
                form.append("street_no", document.getElementById('txtStreetNo').value);
                form.append("street", document.getElementById('txtStreet').value);
                form.append("suite_appt_floor", document.getElementById('txtSuiteAptFloor').value);
                form.append("city", document.getElementById('txtCity').value);
                form.append("zip", document.getElementById('txtZip').value);
                form.append("state_code", document.getElementById('selectState').value);
                form.append("county_code", document.getElementById('selectCounty').value);
                var loc = $("#prefixurl").val();
                setCookie("ll_prefix_url", loc, 1);
                if (sl.indexOf(s) < 0) {
                    setCookie("ll_state", s, 1);
                    setCookie("ll_state_error", "yes", 1);
                    window.location.href = loc;
                }
                else {
                    $.ajax({
                        url: loc + '/RateOptions',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $loading.show();
                        },
                        success: function (response) {
                            $loading.hide();
                            if (response == "ok")
                                window.location.href = loc + "/SearchRateOptions";
                            else
                                window.location.href = loc;
                        }
                    });
                }
            }
            else
                return false;
        });

        $("#btnStarted").attr("disabled", "disabled");
        $("#btnStarted").addClass("disabled");
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
        script.async = true;
        document.body.appendChild(script);

        $('#btnStarted').click(function (e) {
            e.preventDefault();
            var form = new FormData();
            var selectedState = document.getElementById("selectState");
            var s = selectedState.options[selectedState.selectedIndex].text;
            setCookie("ll_state_error", "no", 1);
            form.append("state_lisenced", $("#state_lisenced").val());
            var sl = $("#state_lisenced").val();
            form.append("member_id", $("#member_id").val());
            form.append("branch_orgid", $("#branch_orgid").val());
            form.append("street_no", document.getElementById('txtStreetNo').value);
            form.append("street", document.getElementById('txtStreet').value);
            form.append("suite_appt_floor", document.getElementById('txtSuiteAptFloor').value);
            form.append("city", document.getElementById('txtCity').value);
            form.append("zip", document.getElementById('txtZip').value);
            form.append("state_code", document.getElementById('selectState').value);
            form.append("county_code", document.getElementById('selectCounty').value);
            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            if (sl.indexOf(s) < 0) {
                setCookie("ll_state", s, 1);
                setCookie("ll_state_error", "yes", 1);
                window.location.href = loc;
            }
            else {
                $.ajax({
                    url: loc + '/RateOptions',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response == "ok")
                            window.location.href = loc + "/SearchRateOptions";
                        else
                            window.location.href = loc;
                    }
                });
            }
        });

        $('#modal-confirmation').keypress(function (e) {
            if (e.keyCode == 13) {
                $('#btnConfirm').click();
            }
        });

        $('#btnConfirm').on('click',function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);

                $.ajax({
                    url: loc + '/check?id=' + $("#txtConfirmationNumber").val(),
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $loading.show();
                    },
                    data: "",
                    success: function (response) {
                        $loading.hide();
                        if (response.success)
                            window.location.href = response.redirectUrl
                    }
                });
        });

        $('#btnResent').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            var formData = new FormData();
            formData.append("resentemail", $("#txtREmail").val());
            $.ajax({
                url: loc + '/CheckAndResend',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/information?status=ok';
                    }
                    else {
                        window.location.href = loc + '/information?status=error';
                    }
                }
            });
        });

        $('#btnAlreadyExist').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);

            $.ajax({
                url: loc + '/AlreadyExist',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/SearchRateOptions';
                    }
                }
            });
        });
    }

    if ($('#search_rate_options_page').length) {
        var $loading = $('#ll_loading-div');

        $(document).ready(function () {
            $loading.hide();
            document.getElementById("hdnNoOfUnits").value = 1;
            $('select').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                document.getElementById("hdnNoOfUnits").value = this.value;
            });
        });
        $('#multi').change(function () {
            if (this.checked) {
                $('#div-multi').css("display", "block");
                document.getElementById("noUnits").attr('required', '');
            } else {
                $('#div-multi').css("display", "none");
                $("#noUnits").removeAttr('required');
                document.getElementById("hdnNoOfUnits").value = 1;
            }
        });

        $('#btnSearch').click(function (e) {
            e.preventDefault();
            if ($('#search-form').valid()) {
                if ($('#multi').is(":checked")) {
                    var n = document.getElementById("hdnNoOfUnits").value;
                    if (n < 2) {
                        alert("Please select the No. of Units");
                        return false;
                    }
                }
                var form = new FormData();

                form.append("sellerconcession", document.getElementById('sellerinput').value);
                form.append("salesprice", document.getElementById('salesinput').value);
                form.append("noUnits", document.getElementById('hdnNoOfUnits').value);

                form.append("propertytype", $("input:radio[name='propertytype']:checked").val());
                form.append("contribution_cmg", document.getElementById('contribution_CMG').value);
                form.append("contribution_agent", "0.00");
                var loc1 = $("#prefixurl").val();
                $.ajax({
                    url: loc1 + '/get-rate-options',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        if (response == "ok") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else if (response == "nodata") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else {
                            window.location.href = loc1;
                        }
                    }
                });
            }
            else
                return false;
        });
    }

    if ($('#ll_property_page').length) {
        $(function () {
            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            $(document).ready(function () {
                $(":input").inputmask();

                $("#phone").inputmask("(999) 999-9999", { clearIncomplete: true });
            });

            $('#email').on('input', function () {
                validateEmail(this);
            });

            $('#firstname').on('input', function () {
                validateFirstName(this);
            });
            $('#lastname').on('input', function () {
                validateLastName(this);
            });
            function validateFirstName(input) {
                var a = input.value;
                const errorMessage = document.getElementById('error-message-firstname');
                if (a.trim().length <= 0) {
                    errorMessage.textContent = 'This field is required.';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };

            function validateLastName(input) {
                var a = input.value;
                const errorMessage = document.getElementById('error-message-lastname');
                if (a.trim().length <= 0) {
                    errorMessage.textContent = 'This field is required.';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };
            $('#modal-PropertyEnquiry').keypress(function (e) {
                if (e.keyCode == 13) {
                    $('#btnPropertyEnquirySubmit').click();
                }
            });

            function validateEmail(input) {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const errorMessage = document.getElementById('error-message');
                if (!emailPattern.test(input.value)) {
                    errorMessage.textContent = 'Invalid email format';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };

            $('#btnPropertyEnquirySubmit').on('click', function (e) {
                e.preventDefault();

                if ($('#modalPropertyEnquiry-form').valid()) {
                    var form = new FormData();

                    var fn = document.getElementById('firstname').value.trim();
                    var ln = document.getElementById('lastname').value.trim();
                    var ph = document.getElementById('phone').value.trim();
                    var email = document.getElementById('email').value.trim();

                    if (fn == '' || ln == '' || ph == '' || email == '' ) {
                        return false;
                    }

                    form.append("lisitingadd", document.getElementById('hdnListingAdd').value.trim());
                    form.append("firstname", document.getElementById('firstname').value.trim());
                    form.append("lastname", document.getElementById('lastname').value.trim());
                    form.append("phone", document.getElementById('phone').value.trim());
                    form.append("email", document.getElementById('email').value.trim());
                    form.append("sellerid", document.getElementById('hdnSellerID').value.trim());
                    form.append("loannumber", document.getElementById('hdnConfirmationNumber').value.trim());
                    form.append("confirmationUrl", window.location.hostname + document.getElementById('prefixurl').value.trim() + "/confirmation?id=" + document.getElementById('hdnConfirmationNumber').value.trim());


                    $.ajax({
                        url: $("#prefixurl").val() + "/property-enquiry-submit",
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        success: function (response) {
                            if (response == "ok") {
                                $("#modal-PropertyEnquiry").modal("hide");
                                $("#modal-propertyEnquirysuccess").modal("show");
                            }
                            else {
                                $("#modal-PropertyEnquiry").modal("hide");
                                $("#modal-propertyEnquiryfailure").modal("show");
                            }
                        }
                    });
                }
                else {
                    return false;
                }
            });
            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle="popover"]').popover({
                html: true,
                content: function () {
                    return $(this).next('.popper-content').html();
                }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });

            $('[data-toggle="tooltip"]').tooltip();

            // Poll for property video completion when it is still pending
            if ($('#property_video').is('.pending')) {
                var propertyVideoCounter = 0;

                var cTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=property")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.status === 'Error') {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;
                                $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                                return;
                            }

                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;

                                // Use the existing house image thumbnail if available; otherwise fall back to video preview
                                var existingThumbnail = $('#property_video [data-role="thumbnail"]').attr('data-src');
                                var thumbnailUrl = (existingThumbnail && existingThumbnail.length > 0 && !existingThumbnail.includes('ll-loading.gif'))
                                    ? existingThumbnail
                                    : data.previewURL;

                                if (thumbnailUrl && thumbnailUrl.length > 0) {
                                    $('#property_video [data-role="thumbnail"]').attr('data-src', thumbnailUrl);
                                    $('#property_video [data-role="thumbnail"]').css('background-image', 'url("' + thumbnailUrl + '")');
                                }
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);

                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                new VideoPlayer();
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoCounter++;

                            if (propertyVideoCounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                            }
                        });
                }, 1000);
            }

            // If collaterals are regenerating, poll for the flyer completion and re-enable the download button
            if ($('#hdnCollateralsRefresh').val() === 'true') {
                var flyerPollCounter = 0;
                var flyerTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=flyer")
                        .done(function (data) {
                            if (data.status === 'Error') {
                                flyerPollCounter = listNLockVideoGenerationTimeout;
                                $('#flyerErrorMsg').text('Unable to generate flyer. Please try again from the confirmation page.').show();
                                clearInterval(flyerTimer);
                                return;
                            }

                            if (data.documentUrl && data.documentUrl.length > 0) {
                                flyerPollCounter = listNLockVideoGenerationTimeout;
                                $('#flyerDownloadLink').attr('href', data.documentUrl).removeClass('disabled');
                                clearInterval(flyerTimer);
                            }
                        })
                        .fail(function () {
                            flyerPollCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            flyerPollCounter++;
                            if (flyerPollCounter > listNLockVideoGenerationTimeout) {
                                $('#flyerErrorMsg').text('Flyer generation timed out. Please try again from the confirmation page.').show();
                                clearInterval(flyerTimer);
                            }
                        });
                }, 3000);
            }

        });
    }

    if ($('#locknlist_esign_page').length) {
        $('iframe').on('load', function () {
            $('iframe').contents().find("head")
                .append($("<style type='text/css'> #welcome-wrapper{display:none;}  </style>"));
        });
    }

    if ($('#locknlist_payment_success').length) {
        var returnUrl = $('#locknlist_payment_success').data('url');

        createLoan(returnUrl, 0);
    }

    if ($('#locknlist_presentation_page').length) {
        var page1Url = $('#hdnUrl1').val();
        var page2Url = $('#hdnUrl2').val();
        var presentationUrl = $('#hdnUrl').val();

        // Helper function to check if URL needs generation
        function needsGeneration(url) {
            return url.length === 0 ||
                   url.startsWith("ERROR:") ||
                   url === "Resource URL is not provided";
        }

        if (presentationUrl.length > 0 && presentationUrl != "Pending" && !presentationUrl.startsWith("ERROR:")) {
            $("#pdfimg").attr("src", page1Url);
            return;
        }

        var $loading = $('#ll_loading-div').hide();
        $("#pdfimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");

        if (needsGeneration(page1Url)) {
            $.post('generate-presentationpage1-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl1').val("Pending");
                })
                .fail(function (xhr, status, error) {
                    console.error(`Error in generate-presentationpage1-background. Status: ${status} error: ${error}`);
                    $('#hdnUrl1').val("ERROR: Failed to start generation");
                });
        }

        if (needsGeneration(page2Url)) {
            $.post('generate-presentationpage2-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl2').val("Pending");
                })
                .fail(function (xhr, status, error) {
                    console.error(`Error in generate-presentationpage2-background. Status: ${status} error: ${error}`);
                    $('#hdnUrl2').val("ERROR: Failed to start generation");
                });
        }

        if ($('#merge_pdf').is('.pending')) {
            var pdfCounter = 0;
            var id = $('#hdnID').val();
            var cTimer = setInterval(() => {
                $.get("pdf-upload-status?id=" + $('#hdnID').val() + "&type=presentation")
                    .done(function (data, textStatus, jqXHR) {
                        if (data.pdfUrl && data.pdfUrl.length > 0) {
                            pdfCounter = 90;
                            $('#instructions-div').addClass('d-none');
                            $('.heading-row').removeClass('d-none');
                            $('#merge_pdf').removeClass('pending');
                            $('#pdflink').attr('href', data.pdfFile);
                            $("#pdfimg").attr("src", data.previewURL);
                        }
                    })
                    .fail(function (xhr, status, error) {
                        console.error(`Error in pdf-upload-status request. Status: ${status} error: ${error}`);
                        pdfCounter = 90;
                    })
                    .always(function () {
                        pdfCounter++;

                        if (pdfCounter > 90) {
                            $('#instructions-div p').text('Unable to generate presentation file. Please try again.').addClass('upload-error');
                            clearInterval(cTimer);
                        }
                    });
            }, 2000);
        }
    }
});

function createLoan(url, retryAttempt) {
    $.post(url)
        .done(function (data) {
            if (data.success) {
                window.location.href = data.redirectUrl;
            }
            else {
                $('.label-error').removeClass('d-none');
                $('.dev-error h6').text(data.errorMessage);
                $('.label').addClass('d-none');
                $('img').addClass('d-none');
            }
        })
        .fail(function (xhr, status, error) {
            if (xhr.status === 503) {
                alert.log('error 503')
                retryAttempt++;
                if (retryAttempt < 4) {
                    createLoan(returnUrl, retryAttempt);
                    return;
                }
            }

            $('.label-error').removeClass('d-none');
            $('.dev-error h6').text(`Communication error. xhr: ${JSON.stringify(xhr)}, status: ${JSON.stringify(status)} error: ${JSON.stringify(error)}`);
            $('.label').addClass('d-none');
            $('img').addClass('d-none');
        });

    setTimeout(() => {
        location.reload();
    }, 300000);
}
